import HubSpotIntegration from './HubspotIntegration';
export default HubSpotIntegration;
